import { ACCOUNT_STATUS } from './index';
import { Action } from '../action';
import { AccountStatusState } from '@shared/core';

export class AccountStatusHydrateAction implements Action {
	readonly type = ACCOUNT_STATUS.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AccountStatusHydrateFailureAction implements Action {
	readonly type = ACCOUNT_STATUS.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AccountStatusHydrateSuccessAction implements Action {
	readonly type = ACCOUNT_STATUS.HYDRATE_SUCCESS;
	constructor(
		public payload: AccountStatusState,
		public correlationId?: number
	) {}
}

export class AccountStatusUpdateAction implements Action {
	readonly type = ACCOUNT_STATUS.UPDATE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
